import {FILTERS_GROUPS_IDS} from '../../common/filtersGroups.js'
import {FILTER_NAMES} from '../ads.js'

export const MINIMOTOS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS = {
  [FILTERS_GROUPS_IDS.VEHICLE_TYPE_GROUP_ID]: {
    icon: 'motoClassic',
    label: 'FILTERS_GROUPS.VEHICLE_TYPE.LABEL.MOTOS',
    filters: [FILTER_NAMES.OFFER_TYPE]
  },
  [FILTERS_GROUPS_IDS.MAKE_GROUP_ID]: {
    icon: 'motoMini',
    label: 'FILTERS_GROUPS.MAKE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.SEARCH_TEXT]
  },
  [FILTERS_GROUPS_IDS.PRICE_GROUP_ID]: {
    icon: 'tag',
    label: 'FILTERS_GROUPS.PRICE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.PRICE]
  },
  [FILTERS_GROUPS_IDS.LOCATION_GROUP_ID]: {
    icon: 'poi',
    label: 'FILTERS_GROUPS.LOCATION.LABEL.DEFAULT',
    filters: [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.ONLY_PENINSULA]
  },
  [FILTERS_GROUPS_IDS.SELLER_GROUP_ID]: {
    icon: 'shieldCheck',
    label: 'FILTERS_GROUPS.SELLER.LABEL.DEFAULT',
    filters: [FILTER_NAMES.SELLER_TYPE, FILTER_NAMES.HAS_PHOTO]
  }
}
